// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","316":"component---src-pages-menu-js"}[chunkId] || chunkId) + "-" + {"293":"c4e8b55b498da4cfcf79","316":"7b5fbf32a2a946338f0b","454":"dfd039dda99678d931aa"}[chunkId] + ".js";
};